import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HelmetProvider } from 'react-helmet-async';
import './i18n';
import { API_BASE_URL, LOCAL_API_URL, ONLINE_API_URL_HTTPS, ONLINE_API_URL_HTTP, setApiBaseUrl } from './config';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const checkApiConnectivity = async (url: string, timeoutMs: number = 2000): Promise<boolean> => {
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeoutMs);
    
    // Using lookup/currencies as a lightweight ping endpoint
    await fetch(`${url}/lookup/currencies`, { 
      method: 'HEAD',
      signal: controller.signal
    }).catch(err => {
      if (err.name === 'AbortError' || err.message.includes('Failed to fetch') || err.message.includes('NetworkError')) {
        throw err;
      }
    });
    
    clearTimeout(timeoutId);
    return true;
  } catch (error) {
    return false;
  }
};

const startApp = async () => {
  // Check API connectivity if configured for localhost
  if (API_BASE_URL === LOCAL_API_URL) {
    console.log('🔍 Checking local API connectivity...');
    const isLocalUp = await checkApiConnectivity(LOCAL_API_URL);
    
    if (isLocalUp) {
      console.log('✅ Local API is running');
    } else {
      console.warn('⚠️ Local API unreachable. Trying ONLINE HTTPS API...');
      const isOnlineHttpsUp = await checkApiConnectivity(ONLINE_API_URL_HTTPS, 3000);
      
      if (isOnlineHttpsUp) {
        console.log('✅ Switched to ONLINE HTTPS API');
        setApiBaseUrl(ONLINE_API_URL_HTTPS);
      } else {
        console.warn('⚠️ Online HTTPS unreachable. Trying ONLINE HTTP API...');
        // Fallback to HTTP
        setApiBaseUrl(ONLINE_API_URL_HTTP);
        console.log('✅ Switched to ONLINE HTTP API');
      }
    }
  }

  root.render(
    <HelmetProvider>
      <App />
    </HelmetProvider>
  );
};

startApp();

reportWebVitals();
